import { useEffect, useState } from 'react';
import { getUserGeo } from '../../lib/use-cases/get-user-geo';
import { NON_US_REGION, US_REGION } from '../app-legal-regions';

function useLegalRegion() {
    const [legalRegion, setLegalRegion] = useState(NON_US_REGION);

    const getData = async () => {
        const geoData = await getUserGeo();

        setLegalRegion(geoData.countryCode === US_REGION ? US_REGION : NON_US_REGION);
    };

    useEffect(() => {
        getData();
    }, []);

    return legalRegion;
}

export {
    useLegalRegion
};
